<template>
  <!-- <v-card> -->
  <!-- <card-title-bar icon="mdi-credit-card-outline" text="支払方法"></card-title-bar> -->

  <div>
    <v-radio-group v-model="payment" :mandatory="false">
      <!-- クレジットカード決済 -->
      <v-radio label="クレジットカード決済" :value="paymentCredit"></v-radio>

      <!-- カード入力欄 -->
      <v-container class="pa-0 mb-3">
        <v-row no-gutters>
          <v-col cols="12" sm="6">
            <div class="card-label-container">
              <label for="card-number">
                カード番号
              </label>
            </div>
            <div id="card-number" class="input empty"></div>
          </v-col>
          <v-col cols="6" sm="3">
            <!-- <div id="card-expiry"></div> -->
            <div class="card-label-container">
              <label for="card-expiry">
                有効期限
              </label>
            </div>
            <div id="card-expiry" class="input empty"></div>
          </v-col>
          <v-col cols="6" sm="3">
            <!-- <div id="card-cvc"></div> -->
            <div class="card-label-container">
              <label for="card-cvc">
                セキュリティコード
              </label>
            </div>
            <div id="card-cvc" class="input empty"></div>
          </v-col>
        </v-row>
      </v-container>

      <!-- We'll put the error messages in this element -->
      <div id="card-errors" role="alert" class="mb-3">{{ cardError }}</div>

      <!-- 銀行振込 -->
      <v-radio label="銀行振込" :value="paymentTransfer"></v-radio>
      <ul class="ml-5 py-0 text-caption grey--text">
        <li>注文確認メールに記載する口座まで、代金をお振込いただきます</li>
        <li>振込手数料はお客様にてご負担をお願いいたします</li>
      </ul>

      <!-- 到着時支払い -->
      <template v-if="existGroup">
        <v-radio
          label="配達時支払い（現金）"
          :value="paymentCash"
          class="mb-0"
          :disabled="cashBtnDisabled"
        ></v-radio>
        <ul class="ml-5 py-0 text-caption grey--text">
          <li>グループ / 直接配達でのみ利用いただけます</li>
          <li>
            グループ配送の場合、予めグループ内で代金の取りまとめをお願いします
          </li>
        </ul>
      </template>
    </v-radio-group>
  </div>
  <!-- </v-card> -->
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
// import CardTitleBar from './parts/CardTitleBar'

export default {
  name: 'PaymentSelect',
  components: {
    // CardTitleBar,
  },
  props: {
    paymentCredit: Number,
    paymentTransfer: Number,
    paymentCash: Number,
    existGroup: Boolean,
    cashBtnDisabled: Boolean,
    stripePublicKey: String,
  },
  data: () => ({
    payment: 0,
    // カード決済用Stripeオブジェクト
    stripe: '',
    // カード情報エレメント
    cardNumberElements: null,
    cardExpiryElements: null,
    cardCvcElements: null,
    card: {
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
    },
    cardError: null,
  }),
  computed: {
    // 入力情報
    info() {
      return {
        payment: this.payment,
        stripe: this.stripe,
        cardNumberElements: this.cardNumberElements,
        entered: this.entered,
      };
    },
    // 入力済判定
    entered() {
      if (this.payment == this.paymentCredit) {
        // カード情報不足
        if (
          this.cardError ||
          !this.card.cardNumber ||
          !this.card.cardExpiry ||
          !this.card.cardCvc
        )
          return false;
      }
      return true;
    },
  },
  methods: {
    // 入力検証
    validated() {
      if (this.payment == this.paymentCredit) {
        // クレジットカード決済選択時の入力チェック
        if (!this.card.cardNumber) {
          this.cardNumberElements.focus();
          return false;
        }
        if (!this.card.cardExpiry) {
          this.cardExpiryElements.focus();
          return false;
        }
        if (!this.card.cardCvc) {
          this.cardCvcElements.focus();
          return false;
        }
      }
      return true;
    },
    // クレカ決済エラーセット
    setCardError(err) {
      this.cardError = err;
    },
  },
  async mounted() {
    // カード決済関連コンポーネントの初期化
    this.stripe = await loadStripe(this.stripePublicKey);

    const elements = this.stripe.elements();
    const style = {
      base: {
        color: '#32325D',
        fontWeight: 500,
        fontFamily: 'Roboto, sans-serif',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#CFD7DF',
        },
        ':-webkit-autofill': {
          color: '#e39f48',
        },
      },
      invalid: {
        color: '#E25950',
        '::placeholder': {
          color: '#FFCCA5',
        },
      },
    };

    const classes = {
      focus: 'focused',
      empty: 'empty',
      invalid: 'invalid',
    };

    // カード番号
    this.cardNumberElements = elements.create('cardNumber', {
      style: style,
      classes: classes,
    });
    this.cardNumberElements.mount('#card-number');
    this.cardNumberElements.addEventListener('change', event => {
      this.card.cardNumber = event.complete;

      if (this.card.cardNumber != '' && this.payment != this.paymentCredit)
        this.payment = this.paymentCredit;

      this.cardError = event.error ? event.error.message : '';
      if (event.complete) {
        this.cardExpiryElements.focus();
      }
    });
    this.cardNumberElements.addEventListener('focus', () => {
      if (this.payment != this.paymentCredit) this.payment = this.paymentCredit;
    });

    // 有効期限
    this.cardExpiryElements = elements.create('cardExpiry', {
      style: style,
      classes: classes,
    });
    this.cardExpiryElements.mount('#card-expiry');
    this.cardExpiryElements.addEventListener('change', event => {
      this.card.cardExpiry = event.complete;
      this.cardError = event.error ? event.error.message : '';
      if (event.complete) {
        this.cardCvcElements.focus();
      }
    });
    this.cardExpiryElements.addEventListener('focus', () => {
      if (this.payment != this.paymentCredit) this.payment = this.paymentCredit;
    });

    // CVC
    this.cardCvcElements = elements.create('cardCvc', {
      style: style,
      classes: classes,
    });
    this.cardCvcElements.mount('#card-cvc');
    this.cardCvcElements.addEventListener('change', event => {
      this.card.cardCvc = event.complete;
      this.cardError = event.error ? event.error.message : '';
    });
    this.cardCvcElements.addEventListener('focus', () => {
      if (this.payment != this.paymentCredit) this.payment = this.paymentCredit;
    });
  },
  created() {
    this.payment = this.paymentCredit;
  },
  watch: {
    payment: function() {
      if (this.payment != this.paymentCredit) {
        this.cardNumberElements.clear();
        this.cardExpiryElements.clear();
        this.cardCvcElements.clear();
      }
    },
    info: function() {
      this.$emit('info-changed', this.info);
    },
  },
};
</script>

<style scoped>
.card-label-container {
  /* height: 1.5em; */
  width: 100%;
  display: flex;
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  align-items: center;
}
.card-label-container label {
  pointer-events: none;
}
.input {
  padding: 4px 0 3px 0;
  border-bottom: 1px solid #ddd;
}
#card-errors {
  width: 100%;
  display: flex;
  margin: 0;
  font-size: 11px;
  font-weight: 800;
  color: crimson;
}
</style>
